import { UI_PRIMITIVE__button, UI_PRIMITIVE__button_props } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__icon_animated } from '@/components/ui/UI_PRIMITIVE__icon_animated';
import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { SVGComponent } from '@/types/types';
import React, { forwardRef, useState } from 'react';

interface Props extends UI_PRIMITIVE__button_props {
  onClick: (e: React.MouseEvent<HTMLElement>) => Promise<void> | void;
  Icon: SVGComponent;
  renderDelay?: number;
  iconClassNameBase?: string;
  iconClassNameHovered?: string;
  iconClassNameNonHovered?: string;
  enableAnimation?: boolean;
}

export const UI_PRIMITIVE__button_with_icon_animated = forwardRef<HTMLButtonElement, Props>(
  (
    {
      onClick,
      disabled = false,
      Icon,
      renderDelay = CONSTANTS__client.INSTANT_RENDER_ANIMATION_DELAY,
      className = '',
      iconClassNameBase = '',
      iconClassNameHovered = '',
      iconClassNameNonHovered = '',
      enableAnimation = true,
      size,
      variant,
      children,

      ...props
    },
    ref,
  ) => {
    const [is_hovered, set_is_hovered] = useState(false);

    return (
      <UI_PRIMITIVE__button
        onMouseLeave={() => set_is_hovered(false)}
        onMouseEnter={() => set_is_hovered(true)}
        ref={ref}
        {...props}
        {...{ className, size, variant, disabled, onClick }}
      >
        {children}
        <UI_PRIMITIVE__icon_animated
          enableAnimation={enableAnimation}
          className={iconClassNameBase}
          classNameNonHovered={iconClassNameNonHovered}
          classNameHovered={iconClassNameHovered}
          isHovered={is_hovered}
          Icon={Icon}
          renderDelay={renderDelay}
        />
      </UI_PRIMITIVE__button>
    );
  },
);
